// @flow
import React, { useState, useEffect } from 'react';
import { IconButton, Button } from 'material-ui';
import moment from 'moment';
import Event from '@material-ui/icons/Event';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

const TODAY = moment();

type Props = {
    onDateChange: (date: any) => void
};

export default function DateSelection({ onDateChange }: Props) {
    const [showDate, setShowDate] = useState(false);
    const [date, setDate] = useState(null);
    const [dateFocused, setDateFocused] = useState(false);

    useEffect(
        () => {
            onDateChange(date ? date.format('YYYY-MM-DD') : date);
        },
        /* eslint-disable-next-line */
        [date]
    );

    return (
        <div className="date-selection">
            <Button
                className={`date-selection-button latest-button ${!showDate &&
                    'selected'}`}
                onClick={() => {
                    setShowDate(false);
                    setDate(false);
                    setTimeout(() => {
                        setDate(null);
                    });
                }}
            >
                latest
            </Button>

            {!showDate && (
                <IconButton
                    className="date-selection-button calendar-button"
                    aria-label="Calendar"
                    onClick={() => {
                        setDate(TODAY);
                        setShowDate(true);
                        setDateFocused(true);
                    }}
                    data-testid="show-date-selection-button"
                >
                    <Event className="calendar-icon" />
                </IconButton>
            )}
            {showDate && (
                <div className="date-selector">
                    <IconButton
                        className="date-selection-button calendar-button"
                        aria-label="Calendar"
                        onClick={() => {
                            const previousDate = moment(date).subtract(
                                1,
                                'days'
                            );
                            setDate(previousDate);
                        }}
                    >
                        <ChevronLeft className="calendar-icon" />
                    </IconButton>
                    <SingleDatePicker
                        className="date-picker"
                        noBorder
                        date={date}
                        isOutsideRange={() => false}
                        onDateChange={(newDate: any) => setDate(newDate)}
                        focused={dateFocused}
                        displayFormat="dddd, MMMM DD, YYYY"
                        onFocusChange={({ focused }: any) =>
                            setDateFocused(focused)
                        }
                        id="date-range-picker"
                        data-testid="date-range-picker"
                    />
                    <IconButton
                        className="date-selection-button calendar-button"
                        aria-label="Calendar"
                        onClick={() => {
                            const previousDate = moment(date).add(1, 'days');
                            setDate(previousDate);
                        }}
                    >
                        <ChevronRight className="calendar-icon" />
                    </IconButton>
                </div>
            )}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/v5/home/components/DateSelection.jsx